/**
 * @namespace {BX.UI}
 */
export default class ProgressRoundColor
{
	static DEFAULT = 'ui-progressround-default';
	static DANGER = "ui-progressround-danger";
	static SUCCESS = "ui-progressround-success";
	static PRIMARY = "ui-progressround-primary";
	static WARNING = "ui-progressround-warning";
}
